<template>
  <div class="error-section" v-show="true">
    <!-- <p
      class="error-msg"
      v-for="(error,index) in inputError"
      :key="index"
    >{{Object.keys(error) | adjustName}} : Inválido</p>-->
    <slot></slot>
  </div>
</template>
<script>
import ErrorMsg from "./ErrorMsg";
export default {
  name: "ErrorSection",
  props: ["showErrors"],
  data() {
    return {
      inputError: []
    };
  },
  components: {
    ErrorMsg
  }
};
</script>
